import { render, staticRenderFns } from "./DataTransfer.vue?vue&type=template&id=400712a4&scoped=true&"
import script from "./DataTransfer.vue?vue&type=script&lang=js&"
export * from "./DataTransfer.vue?vue&type=script&lang=js&"
import style0 from "./DataTransfer.vue?vue&type=style&index=0&id=400712a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400712a4",
  null
  
)

export default component.exports